export default "__VITE_ASSET__CmMfTPuR__"